// @owners { team: patients-team }
import { format, isAfter, isBefore, isSameDay, isValid, parse, startOfDay } from 'date-fns';
import { DATE_FORMATS } from '~shared/helpers/date';

export type VacationSupplyFormValues = {
  travelDestination: string;
  startDate: string;
  returnDate: string;
};

export const initialFormValues: VacationSupplyFormValues = {
  travelDestination: '',
  startDate: '',
  returnDate: '',
};

export const validateStartDate = (startDate: string, earliestAvailableDate: string) => {
  const startOfToday = startOfDay(new Date());
  const parsedStartDate = parse(startDate, DATE_FORMATS.YEAR_MONTH_DAY_DASHED, 0);
  const parsedEarliestAvailableDate = parse(earliestAvailableDate, DATE_FORMATS.YEAR_MONTH_DAY_DASHED, 0);
  const formattedEarliestAvailableDate = format(parsedEarliestAvailableDate, DATE_FORMATS.DATE_INPUT_FORMAT).replace(
    / \/ /g,
    '/',
  );

  if (startDate === '' || !isValid(parsedStartDate)) {
    return 'Please enter a start date in the MM/DD/YYYY format';
  }

  if (isBefore(parsedStartDate, startOfToday) || isAfter(parsedStartDate, parsedEarliestAvailableDate)) {
    return `Start date must be between today and ${formattedEarliestAvailableDate}`;
  }

  return true;
};

export const validateReturnDate = (returnDate: string, earliestAvailableDate: string) => {
  const parsedReturnDate = parse(returnDate, DATE_FORMATS.YEAR_MONTH_DAY_DASHED, new Date());
  const parsedEarliestAvailableDate = parse(earliestAvailableDate, DATE_FORMATS.YEAR_MONTH_DAY_DASHED, 0);
  const formattedEarliestAvailableDate = format(parsedEarliestAvailableDate, DATE_FORMATS.DATE_INPUT_FORMAT).replace(
    / \/ /g,
    '/',
  );

  if (returnDate === '' || !isValid(parsedReturnDate)) {
    return 'Please enter a return date in the MM/DD/YYYY format';
  }

  if (
    isBefore(parsedReturnDate, parsedEarliestAvailableDate) ||
    isSameDay(parsedReturnDate, parsedEarliestAvailableDate)
  ) {
    return `Return date must be after ${formattedEarliestAvailableDate}`;
  }

  return true;
};
